export default __webpack_public_path__ + "static/media/110.2130cfa9.svg";